import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchConventionnementByHFId, loadingUser } from "../action";


export const useConvention = () => {
    const dispatch = useDispatch();

    const token = localStorage.getItem("token");

    const userData = useSelector((state) => state.profileReducer);
    const fosaInfo = useSelector((state) => state.fosaReducer);

    useEffect(() => {
        const loadUserData = async () => {
            await dispatch(loadingUser(token));
        };


        loadUserData().then(() => {
            const healthFacilityId = userData?.currentUserResponseData?.i_user?.health_facility_id;
            if (healthFacilityId) {
                dispatch(fetchConventionnementByHFId(healthFacilityId)) 
            }
        });
    }, [dispatch, userData?.currentUserResponseData?.i_user?.health_facility_id]);

    const conventionnement = fosaInfo?.Conventionnement?.[0];
    const conventionnementFetched = fosaInfo?.fetchedConventionnementData;
    const isStatutActive =  fosaInfo?.Conventionnement?.[0]?.status === "ACTIVE";


    const isConventionnementActive = conventionnementFetched ? conventionnement && (isStatutActive && isDateInRange(conventionnement?.validityFrom, conventionnement?.validityTo)) : true;

    const showReason = (conv) => {
        if(!conv) return "Vous n'avez pas de conventionnement"
        if(conv?.status === "DRAFT") return "Conventionnement en draft"
        if(!isDateInRange(conv?.validityFrom)) return "Conventionnement expiré ou pas encore actif"
        return conv?.blockageReason
    }

    return {
        isConventionnementActive,
        blockageReason: showReason(conventionnement)
    }
}

const isDateInRange = (validityFrom) => {
    const now = new Date();
    const from = validityFrom ? new Date(validityFrom) : null;
    
    // If no dates provided, return false
    if (!from) return false;
    
    return now >= from 
};
